import { MediaType, ProductCategory } from "@utils/constants";
import {
  isDiamondOrLabGrown,
  isGemstone,
  isJewelry,
} from "@utils/product/productValidators";
import { useMemo, useState } from "react";
import { filterCertificate, filterInvalidMedia } from "../utils/utils";

interface UsePdpMediaStateProps {
  itemDetail: any;
  product_type: ProductCategory;
  isModal: boolean;
  componentData?: any;
  getDiamondDetailData?: any;
  isCertificateShow: boolean;
}

export const usePdpMediaState = ({
  itemDetail,
  product_type,
  isModal,
  componentData,
  getDiamondDetailData,
  isCertificateShow,
}: UsePdpMediaStateProps) => {
  const [mediaActiveIndex, setMediaActiveIndex] = useState(0);
  const [stickyHeaderActiveIndex, setStickyHeaderActiveIndex] = useState(0);

  const receivedDiamondData = useMemo(() => {
    if (isDiamondOrLabGrown(product_type)) {
      const filteredMedia = filterInvalidMedia(
        componentData && isModal
          ? componentData?.media
          : isModal
          ? getDiamondDetailData?.data?.data?.response?.body?.diamonds?.[0]
              ?.media
          : itemDetail?.media
      );
      return isCertificateShow
        ? filterCertificate(filteredMedia)
        : filteredMedia;
    } else if (isGemstone(product_type)) {
      const filteredMedia = filterInvalidMedia(
        componentData && isModal
          ? componentData?.media
          : isModal
          ? getDiamondDetailData?.data?.data?.response?.body?.gemstones?.[0]
              ?.media
          : itemDetail?.media
      );
      return isCertificateShow
        ? filterCertificate(filteredMedia)
        : filteredMedia;
    } else if (isJewelry(product_type)) {
      const filteredMedia = filterInvalidMedia(itemDetail?.media);
      if (
        filteredMedia &&
        Array.isArray(filteredMedia) &&
        itemDetail?.three_d_enabled
      ) {
        filteredMedia.unshift({
          type: MediaType.MODEL_3D,
          link: process.env.EXPO_PUBLIC_THREE_D_IFRAME_URL,
          thumb: "",
          order: 1,
        });
      }
      return isCertificateShow
        ? filterCertificate(filteredMedia)
        : filteredMedia;
    }
    return [];
  }, [
    product_type,
    isCertificateShow,
    itemDetail,
    getDiamondDetailData.isSuccess,
    componentData,
  ]);

  return {
    mediaActiveIndex,
    setMediaActiveIndex,
    stickyHeaderActiveIndex,
    setStickyHeaderActiveIndex,
    receivedDiamondData,
  };
};
